import RecordingSearch from 'components/recordingSearch'
// import './search.scss';

function Search() {
    return (
        <RecordingSearch />
    )
}

export default Search;
